import {
  createSlice,
  createAsyncThunk,
  createSelector } from
'@reduxjs/toolkit';
import { ApolloClient, gql, NormalizedCacheObject } from '@apollo/client';
import { RootState } from '@src/redux/store';
import * as TYPES from '@src/redux/types';

const GRAPHQL = gql`
  query getBase64FromUrl($data: fileUrlInput!) {
    getBase64FromUrl(data: $data) {
      base64
      error {
        message
        statusCode
      }
    }
  }
`;

const initialState: TYPES.FileBase64State = {
  result: null,
  error: null,
  loading: false
};

export const getBase64FromUrlRequest = createAsyncThunk<
  TYPES.FileBase64,
  {data: TYPES.FileUrlInput;},
  {extra: ApolloClient<NormalizedCacheObject>;}>(

  'system_file/get_base64_from_url',
  async (params: {data: TYPES.FileUrlInput;}, { extra: client }) => {
    try {
      const response = await client.query({
        query: GRAPHQL,
        variables: params
      });
      return response.data.getBase64FromUrl;
    } catch (error) {
      const err = error as {message?: String;statusCode?: String;};
      return Promise.reject({
        message: err.message || 'An error occurred',
        statusCode: err.statusCode || '500'
      });
    }
  }
);

const getBase64FromUrlSlice = createSlice({
  name: 'get_base64_from_url',
  initialState: initialState,
  reducers: {
    getBase64FromUrlClear: (state) => {
      state.result = null;
      state.error = null;
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder.
    addCase(getBase64FromUrlRequest.pending, (state) => {
      state.result = null;
      state.error = null;
      state.loading = true;
    }).
    addCase(getBase64FromUrlRequest.fulfilled, (state, action) => {
      state.result = action.payload;
      state.loading = false;
    }).
    addCase(getBase64FromUrlRequest.rejected, (state, action) => {
      state.error = action.payload as Error || {
        message: 'Failed to fetch',
        statusCode: '500'
      };
      state.loading = false;
    });
  }
});

export const { getBase64FromUrlClear } = getBase64FromUrlSlice.actions;

export const getBase64FromUrl = createSelector(
  (state: RootState) => state.systemFile.getBase64FromUrl.result,
  (state: RootState) => state.systemFile.getBase64FromUrl.error,
  (state: RootState) => state.systemFile.getBase64FromUrl.loading,
  (result, error, loading) => ({
    result,
    error,
    loading
  })
);

export default getBase64FromUrlSlice.reducer;